import { baseRoute } from '../../../constants/routes';

export const QUESTIONS_ROUTE = baseRoute + '/questions';
export const QUESTION_COVER_ROUTE = baseRoute + '/question-cover';
export const QUESTION_FEEDBACK_ROUTE = baseRoute + '/question-feedback';
export const QUESTION_DELETE_ROUTE = baseRoute + '/questions';
export const QUESTION_COPY_ROUTE = baseRoute + '/question-copy';
export const QUESTION_HIDE_ROUTE = baseRoute + '/question-visibility';
export const QUESTION_PIN_ROUTE = baseRoute + '/question-pin';
export const QUESTION_FEEDBACK_SETTINGS_ROUTE = baseRoute + '/feedback-settings';
export const QUESTION_DROP_ROUTE = baseRoute + '/quizzes/order-questions';

export const CREATE_QUESTION = 'CREATE_QUESTION';
export const CREATE_QUESTION_SUCCESS = 'CREATE_QUESTION_SUCCESS';
export const UPDATE_QUESTION = 'UPDATE_QUESTION';
export const UPDATE_QUESTION_SUCCESS = 'UPDATE_QUESTION_SUCCESS';
export const UPLOAD_QUESTION_COVER = 'UPLOAD_QUESTION_COVER';
export const DELETE_QUESTION_COVER = 'DELETE_QUESTION_COVER';
export const DELETE_QUESTION_COVER_SUCCESS = ' DELETE_QUESTION_COVER_SUCCESS';

export const UPLOAD_QUESTION_COVER_SUCCESS = 'UPLOAD_QUESTION_COVER_SUCCESS';
export const UPDATE_QUESTION_FEEDBACK = 'UPDATE_QUESTION_FEEDBACK';
export const UPDATE_QUESTION_FEEDBACK_SUCCESS = 'UPDATE_QUESTION_FEEDBACK_SUCCESS';

export const DELETE_QUESTION = 'DELETE_QUESTION';
export const DELETE_QUESTION_SUCCESS = 'DELETE_QUESTION_SUCCESS';

export const COPY_QUESTION = 'COPY_QUESTION';
export const COPY_QUESTION_SUCCESS = 'COPY_QUESTION_SUCCESS';

export const HIDE_QUESTION = 'HIDE_QUESTION';
export const HIDE_QUESTION_SUCCESS = 'HIDE_QUESTION_SUCCESS';

export const PIN_QUESTION = 'PIN_QUESTION';
export const PIN_QUESTION_SUCCESS = 'PIN_QUESTION_SUCCESS';

export const UPDATE_QUESTION_FEEDBACK_SETTINGS = 'UPDATE_QUESTION_FEEDBACK_SETTINGS';
export const UPDATE_QUESTION_FEEDBACK_SETTINGS_SUCCESS = 'UPDATE_QUESTION_FEEDBACK_SETTINGS_SUCCESS';

export const UPDATE_QUESTION_DRAG_DROP = 'DROP';
export const UPDATE_QUESTION_DRAG_DROP_SUCCESS = 'UPDATE_QUESTION_DRAG_DROP_SUCCESS';

